import { Datagrid, DateField, FunctionField, NumberField, SelectInput, TextField, List } from "react-admin";

// фильтр по адресату аренды: наши кастодиалы vs доливы на кош брокера
const rentalFilters = [
  <SelectInput
    key="on_behalf"
    source="on_behalf"
    label="Адресат"
    alwaysOn
    choices={[
      { id: "broker", name: "Брокеру" },
      { id: "own", name: "Свои кастодиалы" },
    ]}
  />,
];

type Rental = { on_behalf_of: string | null };

export function RentalList() {
  return (
    <List perPage={25} sort={{ field: "created_at", order: "DESC" }} exporter={false} filters={rentalFilters}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <DateField source="created_at" showTime />
        <TextField source="wallet_address" sx={{ fontFamily: "monospace", fontSize: 12 }} />
        <NumberField source="quantity" />
        <TextField source="duration" />
        <NumberField source="price_trx" label="Стоимость, TRX" options={{ maximumFractionDigits: 6 }} />
        <FunctionField
          label="Адресат"
          render={(r: Rental) => (r.on_behalf_of === "broker" ? "Брокеру" : "Свой")}
        />
        <TextField source="status" />
      </Datagrid>
    </List>
  );
}
